'use client';
import { useState } from 'react';
import { useSwipeable } from 'react-swipeable';

type Props = {
  content: any[];
  children: React.ReactNode[];
  bgColor: 'ligth' | 'dark';
};

export const HomeSwipper = ({ content, children, bgColor }: Props) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex < content.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : content.length - 1
    );
  };

  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  const getSlidersDotsColors = (index: number) => {
    if (bgColor === 'dark') {
      return activeIndex === index ? 'bg-[#0b0b0b]' : 'bg-[#cecece]';
    }

    return activeIndex === index ? 'bg-white' : 'bg-[#3c3c3c]';
  };

  return (
    <div>
      <div
        {...handlers}
        className="flex max-w-full justify-center overflow-hidden"
      >
        <div
          className="flex transition-transform duration-500"
          style={{
            transform: `translateX(-${activeIndex * 100}%)`,
            width: `${content.length * 100}%`,
          }}
        >
          {children}
        </div>
      </div>

      <button
        aria-hidden
        tabIndex={-1}
        onClick={handlePrev}
        aria-label="previous"
        className="absolute left-4 top-1/2 hidden -translate-y-1/2 transform rounded-full bg-gray-800 p-2 text-white hover:bg-gray-600 lg:block"
      >
        &larr;
      </button>
      <button
        aria-hidden
        tabIndex={-1}
        aria-label="next"
        onClick={handleNext}
        className="absolute right-4 top-1/2 hidden -translate-y-1/2 transform rounded-full bg-gray-800 p-2 text-white hover:bg-gray-600 lg:block"
      >
        &rarr;
      </button>

      <div className="mt-4 flex justify-center gap-2">
        {content.map((_, index) => (
          <button
            aria-label="slide"
            aria-hidden
            tabIndex={-1}
            key={index}
            className={`${getSlidersDotsColors(index)} size-4 rounded-full`}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};
